// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import Vuex from 'vuex'
import blobalVariable from './utils/global_variable'
import App from './App'
import router from './router'
import store from './store'
import WebIM from './utils/WebIM'  
import ElementUI from 'element-ui'
import httpRequest from '@/server/http-api'
import filter from '@/filter/filter'
import permission from '@/utils/permission'
// import "babel-polyfill";
import moment from 'moment';
import VueAreaLinkage from 'vue-area-linkage'
import VueCropper from 'vue-cropper'

window.jQuery = $;
window.$ = $;

import 'element-ui/lib/theme-chalk/index.css'
import '@/../static/css/reset.css'        /*引入公共样式-重置文件*/
import '@/../static/css/show_ui.css'        /*引入公共样式-重置文件*/
import '@/../static/css/text_html.css'        /*引入公共样式-富文本文件*/

Vue.config.productionTip = false
Vue.prototype.$store = store
Vue.prototype.$client = httpRequest
Vue.prototype.GLOBAL_VARIABLE = blobalVariable
Vue.use(VueAreaLinkage)
Vue.use(VueCropper)

Vue.use(ElementUI)
Vue.use(Vuex)
Vue.filter('dateformat', function(dataStr, pattern = 'YYYY.MM.DD') {
  return moment(dataStr).format(pattern)
})
  // <span>发表时间：{{ item.date | dateformat('YYYY.MM.DD')}}</span>

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>',
  store,
  WebIM
})



// WEBPACK FOOTER //
// ./src/main.js